import {Box, Typography, useTheme} from "@mui/material";

const DOT_COLORS = ["#27AE60", "#EB5292", "#2F80ED", "#F2994A"];

const KpiGroupCard = ({icon: Icon, iconColor, iconBg, title, total, items = [], denied = false}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: theme.palette.card.background,
        border: `1px solid ${theme.palette.card.border}`,
        borderRadius: theme.palette.card.borderRadius,
        boxShadow: theme.palette.card.borderShadow
      }}
    >
      <Box sx={{display: "flex", alignItems: "center", gap: 2, mb: 2}}>
        <Box
          sx={{
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            backgroundColor: iconBg,
            flexShrink: 0,
            lineHeight: 0
          }}
        >
          <Icon sx={{color: iconColor, display: "block", m: "auto"}} />
        </Box>
        <Box>
          <Typography variant="body2" color={theme.palette.text.secondary}>
            {title}
          </Typography>
          <Typography variant="h4" fontWeight="bold" color={theme.palette.text.primary}>
            {total ?? "—"}
          </Typography>
        </Box>
      </Box>

      {denied ? (
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Sin permisos para consultar este recurso
        </Typography>
      ) : (
        items.map(({key, label, value}, index) => (
          <Box key={key} sx={{display: "flex", alignItems: "center", gap: 1.5, py: 0.75}}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: DOT_COLORS[index % DOT_COLORS.length],
                flexShrink: 0
              }}
            />
            <Typography variant="body2" color={theme.palette.text.secondary} sx={{flexGrow: 1}}>
              {label}
            </Typography>
            <Typography variant="body2" fontWeight="bold" color={theme.palette.text.primary}>
              {value ?? "—"}
            </Typography>
          </Box>
        ))
      )}
    </Box>
  );
};

export default KpiGroupCard;
